import { render } from "./LiuYueLiuRi.vue?vue&type=template&id=38d0510d&scoped=true"
import script from "./LiuYueLiuRi.vue?vue&type=script&lang=js"
export * from "./LiuYueLiuRi.vue?vue&type=script&lang=js"

import "./LiuYueLiuRi.vue?vue&type=style&index=0&id=38d0510d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d0510d"]])

export default __exports__